import axiosInstance from '@/utils/api.js'

function validation (payload) {
  // if (payload.validation_flags === 4 && payload.value_type === 1) {
  //   payload.raw_values[0].value = parseInt(payload.raw_values[0].value, 10)
  // }
}

var state = {
  registrySettingGroups: [],
  registrySettings: []
}

var getters = {
  REGISTRY_SETTING_GROUPS: (state) => {
    return state.registrySettingGroups
  },
  REGISTRY_SETTINGS: (state) => {
    return state.registrySettings
  }
}

var mutations = {
  SET_REGISTRY_SETTING_GROUPS: (state, payload) => {
    state.registrySettingGroups = payload
  },
  SET_REGISTRY_SETTINGS: (state, payload) => {
    state.registrySettings = payload
  }
}

var actions = {
  GET_REGISTRY_SETTING_GROUPS: async (context, payload) => {
    let result = await axiosInstance.get('/settings/registry_settings_group?comp_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_REGISTRY_SETTING_GROUPS', result.data)
    }
  },
  GET_REGISTRY_SETTINGS: async (context, payload) => {
    let result = await axiosInstance.get('/settings/registry_settings_form?group_id=' + payload.group_id + '&object_id=' + payload.object_id)
    if (result.status === 200) {
      context.commit('SET_REGISTRY_SETTINGS', result.data)
    }
  },
  UPDATE_REGISTRY_SETTING: (context, payload) => {
    validation(payload)
    return axiosInstance.put('/settings/registry_setting', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/registrySettings.js